import * as d3 from 'd3';
import { defineTexturedGlassPatterns } from './../glassPatternsDefs';
//import { drawArchGridShape } from './../drawArchGrid';
import { drawHalfEllipseShape } from '../drawHalfEllipseShape';

// Helper function to draw left quarter arch shape
function drawLeftQuarterArchShape(
  svg,
  initX,
  initY,
  w,          // final quarter width
  hRect,
  archHeight,
  frameWidth = 10,
  frameColor = 'white',
  lineFrameColor = 'black',
  outerStrokeColor = 'black',
  outerStrokeWidth = 1,
  color = '#EDF9FF',
  includeInnerTopLine = false,
  glassType = null,
  glassDesign = null
) {
  // We call the original function with width = 2*w
  const fullWidth = 2 * w;

  // Create a unique clipPath ID
  const clipId = `clipLeftQuarter_${Math.random().toString(36).substr(2, 9)}`;

  // Define a rectangular clip that keeps only the left half
  svg.append('clipPath')
    .attr('id', clipId)
    .append('rect')
    .attr('x', initX - frameWidth)
    .attr('y', initY - frameWidth)
    .attr('width', w + 2*frameWidth)          // keep only left half
    .attr('height', archHeight + hRect + frameWidth * 2);

  // Create a group that will be clipped
  const g = svg.append('g')
    .attr('clip-path', `url(#${clipId})`);

  // Draw the full half ellipse inside the clipped group
  const innerPoints = drawHalfEllipseShape(
    g,              // draw inside the clipped group
    initX,
    initY,
    fullWidth,      // full half ellipse width
    hRect,
    archHeight,
    frameWidth,
    frameColor,
    lineFrameColor,
    outerStrokeColor,
    outerStrokeWidth,
    color,
    includeInnerTopLine,
    glassType,
    glassDesign,
    'left',
    2               // colNumber = 1 → one vertical bar in the center
  );

  return innerPoints;
}

// Helper function to draw right quarter arch shape
function drawRightQuarterArchShape(
  svg,
  initX,
  initY,
  w,          // quarter width
  hRect,
  archHeight,
  frameWidth = 10,
  frameColor = 'white',
  lineFrameColor = 'black',
  outerStrokeColor = 'black',
  outerStrokeWidth = 1,
  color = '#EDF9FF',
  includeInnerTopLine = false,
  glassType = null,
  glassDesign = null
) {
  const fullWidth = 2 * w;

  const clipId = `clipRightQuarter_${Math.random().toString(36).substr(2, 9)}`;

  // RIGHT HALF CLIP — positioned to show the right quarter of the full ellipse
  // The ellipse center is at initX + w, so the right quarter starts at initX + w
  svg.append('clipPath')
    .attr('id', clipId)
    .append('rect')
    .attr('x', initX + w - frameWidth)
    .attr('y', initY - frameWidth)
    .attr('width', w + 2 * frameWidth)
    .attr('height', archHeight + hRect + frameWidth * 2);

  const g = svg.append('g')
    .attr('clip-path', `url(#${clipId})`);

  // Draw full half ellipse starting at initX (same as left)
  // The ellipse spans from initX to initX + 2*w
  // Center is at initX + w
  const innerPoints = drawHalfEllipseShape(
    g,
    initX,
    initY,
    fullWidth,
    hRect,
    archHeight,
    frameWidth,
    frameColor,
    lineFrameColor,
    outerStrokeColor,
    outerStrokeWidth,
    color,
    includeInnerTopLine,
    glassType,
    glassDesign,
    'right',
    2
  );

  return innerPoints;
}
// Function to draw half eyebrow shapes with frames (similar to shapeTriangle but with curved hypotenuse)
export function shapeHalfEyebrow(svg, d, x, y, halfEyebrows, labelTextOrOptions = null, subFrame = false, fullCorners = false, halfCorners = false,
  displayLabel = true, labelOptions = {}, drawFrame = true) {

  const halfEyebrow = halfEyebrows[0];

  const {
    w,
    h = 100,
    color = 'white',
    glassType = null,
    glassDesign = null,
    frameWidth = 0,
    frameColor = 'white',
    lineFrameColor = 'black',
    outerStrokeColor = 'black',
    outerStrokeWidth = 1,
    orientation = 'left'
  } = halfEyebrow;

  let innerPoints = [];

  if (orientation === 'left') {
    innerPoints = drawLeftQuarterArchShape(
      svg,
      x,
      y,
      w,
      0,
      h,
      frameWidth,
      frameColor,
      lineFrameColor,
      outerStrokeColor,
      outerStrokeWidth,
      color,
      false,
      glassType,
      glassDesign,
      'left'
    );
  }
  if (orientation === 'right') {
    innerPoints = drawRightQuarterArchShape(
      svg,
      x - w,
      y,
      w,
      0,
      h,
      frameWidth,
      frameColor,
      lineFrameColor,
      outerStrokeColor,
      outerStrokeWidth,
      color,
      false,
      glassType,
      glassDesign,
      'right'
    );
  }

  return innerPoints;
}
